import React, { useMemo } from 'react';

import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import useTemplateName from './useTemplateName';
import { useTranslation } from '../i18n';

export const useFormNameColumns = (flagEnabled) => {
  const { t } = useTranslation();
  const { getTemplateName } = useTemplateName();
  return useMemo(() => {
    const columnWidth = flagEnabled ? 150 : 230;

    return {
      columnWidth,
      columns: flagEnabled
        ? [
            {
              header: t('FORM_NAME'),
              accessorKey: 'name',
              minSize: columnWidth,
              size: columnWidth,
              cell: ({ getValue, row }) => {
                const templateName = getTemplateName(row?.original);
                return (
                  <OverflowTooltip>
                    {getValue() || templateName}
                  </OverflowTooltip>
                );
              },
            },
          ]
        : [],
    };
  }, [t, flagEnabled, getTemplateName]);
};
